module.exports = __webpack_public_path__ + "img/mango-juice.1b7e65a8.jpg";